function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#222428;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Calque_2"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Calque_1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M23.6,43.7c-7.8,0-13.2-7.2-17.2-14.2C-3.2,12.8,2.2,6.2,8.1,2.4c1.6-1,3.4-2,5.2-1.4c1.9,0.6,2.8,2.6,4,5.6 c2.2,5.6,1.2,8.6-3.5,10.6c-0.8,0.3-1.3,0.7-1.4,1.1c-0.4,1.2,1.4,4.4,2.6,6.5l0,0c1.2,2.1,3,5.2,4.3,5.5c0.4,0.1,1-0.1,1.7-0.7 c4.1-3.1,7.2-2.4,10.9,2.3c2,2.5,3.3,4.3,2.8,6.2c-0.4,1.8-2.2,2.9-3.8,3.7C28.2,43.1,25.8,43.7,23.6,43.7z M12.1,4.2 c-0.2,0-0.7,0.1-2.2,1c-7.1,4.7-7.3,11-0.6,22.6c8.2,14.3,14.4,13.7,19.9,10.9c1.9-1,2-1.4,2-1.4c0.1-0.5-1.6-2.7-2.2-3.4 c-3.1-3.8-4.1-3.3-6.2-1.7c-1.5,1.1-3,1.6-4.4,1.3C16,33,14.2,30.3,12,26.4l0,0c-2.2-3.8-3.7-6.7-2.9-9.2c0.5-1.4,1.5-2.4,3.3-3.2 c2.4-1,3.4-1.7,1.7-6.2C13.7,6.9,12.7,4.4,12.1,4.2C12.2,4.2,12.2,4.2,12.1,4.2z"
})));

var SvgContact = function SvgContact(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 38.6 45",
    style: {
      enableBackground: "new 0 0 38.6 45"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContact, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact.20e6b282.svg";
export { ForwardRef as ReactComponent };